<banner-app [retroSelected]="false" [Loader]="true" [showPromo]="true"></banner-app>

<div class="main-container" [ngClass]="{ 'config-oneroso': globalConfigOneroso() === true }">
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 form-container">
        <div [ngClass]="{ 'd-none': globalConfigOneroso() === false }" class="block-img">
          <img src="./assets/img/no-pasa-sarlaft.png" alt="" />
        </div>
        <!-- Encabezado -->
        <div class="text-center mb-4">
          <h2 class="texto-cotizacion" [ngClass]="{ 'titulo-onerous': showOnerousStyles() }">{{ title() }}</h2>
          <p class="textos-detalle" [ngClass]="{ 'descripcion-onerous': showOnerousStyles() }"
            [innerHTML]="description()"></p>
        </div>

        <!-- Formulario Único y Responsivo -->
        <form [formGroup]="formulario" (ngSubmit)="siguientePagina()" class="d-flex flex-column align-items-center">
          <!-- Campo Nombre -->
          <div class="form-item-container reactive-validation w-100 mb-3"
            [ngClass]="{ valid: nameValid, invalid: nameInvalid }">
            <label for="name" class="form-label tipo-letra"
              [ngClass]="{ valid: nameValid, invalid: nameInvalid }">*Nombre</label>
            <input type="text" id="name" formControlName="name" class="form-control tipo-letra color-fondo"
              [ngClass]="{ valid: nameValid, invalid: nameInvalid }" placeholder="Ingresa tu nombre" minlength="2"
              maxlength="100" (blur)="onNameBlur()" />
            <small *ngIf="formulario.get('name')?.invalid && formulario.get('name')?.touched"
              class="text-danger tipo-letra">
              Asegúrate de ingresar un nombre válido.
            </small>
          </div>

          <!-- Campo Celular -->
          <div class="form-item-container reactive-validation w-100 mb-3"
            [ngClass]="{ valid: mobilePhoneValid, invalid: mobilePhoneInvalid }">
            <label for="mobile_phone" class="form-label tipo-letra"
              [ngClass]="{ valid: mobilePhoneValid, invalid: mobilePhoneInvalid }">*Número de celular</label>
            <input type="text" id="mobile_phone" formControlName="mobile_phone"
              class="form-control tipo-letra color-fondo"
              [ngClass]="{ valid: mobilePhoneValid, invalid: mobilePhoneInvalid }" placeholder="Ej: 3004263078"
              maxlength="10" autocomplete="off" (blur)="onMobilePhoneBlur()" />
            <small *ngIf="formulario.get('mobile_phone')?.invalid && formulario.get('mobile_phone')?.touched"
              class="text-danger tipo-letra">
              Asegúrate de ingresar un número válido de 10 dígitos.
            </small>
          </div>

          <!-- Campo Correo -->
          <div class="form-item-container reactive-validation w-100 mb-3"
            [ngClass]="{ valid: emailValid, invalid: emailInvalid }">
            <label for="email" class="form-label tipo-letra"
              [ngClass]="{ valid: emailValid, invalid: emailInvalid }">*Correo electrónico</label>
            <input type="email" id="email" formControlName="email" class="form-control tipo-letra color-fondo"
              [ngClass]="{ valid: emailValid, invalid: emailInvalid }" placeholder="Ej: usuario@correo.com"
              (blur)="onEmailBlur()" (keydown)="blockUnicode($event)" />
            <small *ngIf="formulario.get('email')?.invalid && formulario.get('email')?.touched"
              class="text-danger tipo-letra">
              Asegúrate de incluir un correo válido.
            </small>
          </div>

          <!-- Mensaje Campos Obligatorios -->
          <p class="campos-obligatorios align-self-start">*Los campos son obligatorios</p>

          <!-- Checkbox de Autorización -->
          <div class="form-check my-3 w-100">
            <input class="form-check-input" type="checkbox" id="termsAndConditions"
              formControlName="termsAndConditions" />
            <label class="form-check-label" for="termsAndConditions">
              <a (click)="openModal()" class="autorization-text">
                Autorizo a <strong>Suramericana S.A.</strong> el tratamiento de mis datos para las finalidades
                contenidas en la
                <strong>política de privacidad</strong>, donde también se encuentran los canales de contacto y la forma
                de ejercer mis
                derechos.
              </a>
            </label>
          </div>

          <!-- Botón de Envío -->
          <button type="submit" class="btn btn-primary py-2 boton-continuar w-100 mt-3"
            [disabled]="formulario.invalid">Enviar</button>
        </form>
      </div>
    </div>
  </div>

  <br /><br /><br />
  <app-footer-app />
</div>